import { StatusEnum } from "../../hoc/with-status";
import React from "react";
import { Text } from "../typography";
import {
  Button,
  ButtonSize,
  ButtonVariant,
} from "@amzn/stencil-react-components/button";
import { Link } from "@amzn/stencil-react-components/link";
import useArb from "../../hooks/use-arb";

interface ZapposPurchasePromotionProps {
  status: StatusEnum;
  navigateToZappos: () => void;
  decidedIfFirstDayOnsitePassed: () => void;
  hasPassedFirstDayOnsite: boolean;
  taskId: string;
}

export const ZapposPurchasePromotion = ({
  status,
  navigateToZappos,
  decidedIfFirstDayOnsitePassed,
  hasPassedFirstDayOnsite,
  taskId,
}: ZapposPurchasePromotionProps) => {
  const bundle = useArb("HVHChecklistPantherResource");

  const nheCompeletionMessage = bundle.getMessage(
    "Checklist-MindYourStep-NHE-Completion"
  );

  const contingenciesCompletionMessage = bundle.getMessage(
    "Checklist-MindYourStep-Contigencies-Completion"
  );
  const contingenciesCompletionSubMessage = bundle.getMessage(
    "Checklist-MindYourStep-Contigencies-Completion-SubText"
  );
  const discountInfo = bundle.getMessage(
    "Checklist-MindYourStep-Contigencies-Completion-DiscountInfo"
  );
  const purchaseButtonText = bundle.getMessage(
    "Checklist-MindYourStep-Contigencies-Completion-Purchase-ButtonText"
  );
  const needHelpInfo = bundle.getMessage(
    "Checklist-MindYourStep-Candidate-Support"
  );
  const candidateSupportLinkText = bundle.getMessage(
    "Checklist-MindYourStep-Candidate-Support-Link"
  );
  const passFirstDayMessage = bundle.getMessage(
    "Checklist-MindYourStep-Candidate-Pass-First-Day"
  );

  decidedIfFirstDayOnsitePassed();

  const styles = {
    border: "2px dashed rgba(1, 1, 1, 1)",
    color: "black",
    lineHeight: "2.5",
    background: "white",
    width: "100px",
    fontSize: "20px",
  };

  const boxStyle = {
    background: "#D7F3ED",
    padding: "10px",
    border: "1px solid green",
    margin: "10px",
    color: "#008574",
    width: "300px",
    height: "90px",
    textAlign: "center" as const,
    borderLeft: "8px solid green",
  };

  const supportLinkUrl = window.location.origin + "/contact-us";

  if (hasPassedFirstDayOnsite) {
    return <Text>{passFirstDayMessage}</Text>;
  }
  if (status === StatusEnum.ELIGIBLE) {
    return (
      <Text>
        <strong>
          {contingenciesCompletionMessage}
          <br />
        </strong>
        {contingenciesCompletionSubMessage} <br />
        <div style={boxStyle}>
          <strong>
            {discountInfo}
            <br />
          </strong>
          <span style={styles}>{taskId}</span>
        </div>
        <Button
          size={ButtonSize.Small}
          variant={ButtonVariant.Primary}
          onClick={navigateToZappos}
        >
          {purchaseButtonText}
        </Button>
        <br /> {needHelpInfo}{" "}
        <Link href={supportLinkUrl} target="_blank">
          {candidateSupportLinkText}
        </Link>{" "}
      </Text>
    );
  }

  return <Text>{nheCompeletionMessage}</Text>;
};
